import Home from './Home';
import About from './About';
import WhyUs from './WhyUs';
import Services from './Services';
import Contact from './Contact';

const MainPage = () => {
  return (
    <main className="main">
      <Home />
      <About />
      <WhyUs />
      <Services />
      <Contact />
    </main>
  );
};

export default MainPage; 